import { useQuery } from '@tanstack/react-query';

import { ApiFnReturnType } from '@/slw/shared/query-client';

import { checkEmail, getUsers } from './auth.api';

const CHECK_EMAIL_QUERY_KEY = 'auth-check-email';
const GET_USERS_QUERY_KEY = 'auth-get-users';

export const useCheckEmailExist = (email: string, options = {}) => {
  return useQuery<ApiFnReturnType<typeof checkEmail>>({
    queryKey: [CHECK_EMAIL_QUERY_KEY, email],
    queryFn: () => checkEmail(email),
    enabled: !!email,
    ...options,
  });
};

export const useGetUsers = (search: string, options = {}) => {
  return useQuery<ApiFnReturnType<typeof getUsers>>({
    queryKey: [GET_USERS_QUERY_KEY, search],
    queryFn: () => getUsers(search),
    enabled: !!search,
    ...options,
  });
};
